module.exports = __webpack_public_path__ + "static/media/img_6.5400a085.png";